/* eslint-disable max-lines */
import addDays from 'date-fns/addDays';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {
  IStateList,
  ListComponent,
  TableCellSortable,
} from 'components/Abstract/List';
import TableWrapper from 'components/Shared/TableWrapper';
import { WithStyles } from 'decorators/withStyles';
import { IFile } from 'interfaces/file';
import { IPaginationParams } from 'interfaces/pagination';
import { IUserToken } from 'interfaces/userToken';
import React, { Fragment } from 'react';
import { combineLatest } from 'rxjs';
import RxOp from 'rxjs-operators';
import authService from 'services/auth';
import fileService from 'services/file';

import ListItem from './ListItem';

export type Period = number | 'EXPIRED';

interface IState extends IStateList<any> {
  current?: IFile;
  uploadModalOpen?: boolean;
  formOpened?: boolean;
  user?: IUserToken;
}

interface IProps {
  categoryId: number;
  classes?: any;
  bgColor?: string;
  color?: string;
  snapshotDate?: string;
  period: Period;
}

function getPeriod(
  periodDays: Period,
  snapshotDate: string
): { startDate?: Date; endDate?: Date } {
  let startDate, endDate;
  if (periodDays !== 'EXPIRED') {
    const finalStartDate = snapshotDate ? new Date(snapshotDate) : new Date();
    startDate = finalStartDate;
    endDate = addDays(finalStartDate, periodDays);
  }

  return { startDate, endDate };
}

@WithStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(0),
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(2),
  },
  flexRowCentered: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  firstCol: {
    width: '20%',
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
    alignItems: 'center',
    minHeight: theme.spacing(5),
  },
  columnFile: {
    width: '350px',
  },
}))
export default class ExpirationDocumentsTable extends ListComponent<
  IProps,
  IState
> {
  constructor(props: IProps) {
    super(props, 'expirationDate', 'desc');
    this.state = {
      ...this.state,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = (params: Partial<IPaginationParams> = {}) => {
    const { categoryId, period, snapshotDate } = this.props;
    const { startDate, endDate } = getPeriod(period, snapshotDate);
    const mergedParams = this.mergeParams(params);
    combineLatest([
      fileService.listExpirationByCategoryId(categoryId, {
        ...mergedParams,
        startDate,
        endDate,
      }),
      authService.getUser(),
    ])
      .pipe(
        RxOp.bindComponent(this),
        RxOp.logError(),
        RxOp.filter(([items, user]) => Boolean(items || user))
      )
      .subscribe(
        ([items, user]) => {
          this.setPaginatedData(items);
          this.setState({ user });
        },
        (error) => this.setError(error)
      );
  };

  componentDidUpdate(prevProps: IProps) {
    const { period } = this.props;
    if (period !== prevProps.period) {
      this.loadData();
    }
  }

  render() {
    const { items, user } = this.state;
    const { color, bgColor } = this.props;

    return (
      <Fragment>
        <TableWrapper minWidth={1500}>
          <Table>
            <TableHead style={{ backgroundColor: bgColor, color }}>
              <TableRow>
                <TableCellSortable
                  style={{ width: '350px', color: 'inherit' }}
                  column="tab"
                  {...this.sortableProps}
                >
                  Aba
                </TableCellSortable>
                <TableCellSortable
                  style={{ width: '125px', color: 'inherit' }}
                  column="emissionDate"
                  {...this.sortableProps}
                >
                  Documento
                </TableCellSortable>
                <TableCellSortable
                  style={{ width: '157px', color: 'inherit' }}
                  column="filename"
                  {...this.sortableProps}
                >
                  Vencimento
                </TableCellSortable>
                <TableCellSortable
                  style={{ width: '108px', color: 'inherit' }}
                  column="expirationDate"
                  {...this.sortableProps}
                >
                  Vence
                </TableCellSortable>
                <TableCellSortable
                  style={{ width: '172px', color: 'inherit' }}
                  column="frequency"
                  {...this.sortableProps}
                >
                  Periodicidade
                </TableCellSortable>
                <TableCellSortable
                  style={{ width: '110px', color: 'inherit' }}
                  column="status"
                  {...this.sortableProps}
                >
                  Status
                </TableCellSortable>
                <TableCellSortable
                  style={{ width: '124px', color: 'inherit' }}
                  column="uploadDate"
                  {...this.sortableProps}
                >
                  Upload
                </TableCellSortable>
                <TableCellSortable
                  style={{ width: '138px', color: 'inherit' }}
                  column="validationDate"
                  {...this.sortableProps}
                >
                  Validação
                </TableCellSortable>
                <TableCellSortable
                  style={{ width: '149px', color: 'inherit' }}
                  column="criticality"
                  {...this.sortableProps}
                >
                  Criticidade
                </TableCellSortable>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.renderEmptyAndErrorMessages(11)}
              {user &&
                items.map((item) => (
                  <ListItem key={item.id} file={item} user={user} />
                ))}
            </TableBody>
          </Table>
        </TableWrapper>
        {this.renderLoader()}
        {this.renderTablePagination()}
      </Fragment>
    );
  }
}
